
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150.46 144"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"CRS_Initiation","data-name":"CRS Initiation"}},[_c('g',{attrs:{"id":"Stage_-_Initiation","data-name":"Stage - Initiation"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M102.44 43.8l1.81 2.75Q93.2 55.4 79.68 73.8T59 108.2l-3.78 2.8a65 65 0 00-6.45 5.22q-.68-2.58-2.94-8.47l-1.45-3.57a55.85 55.85 0 00-5.75-11.37 13.09 13.09 0 00-6-4.89q5.56-6.27 10.22-6.26 4 0 8.82 11.48l1.6 3.85A158.73 158.73 0 0175.71 66.5q13.68-14.79 26.73-22.7z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M150.46 55.48L93.94 144 1.59 116.5 0 111.89 57.14 17l20.7 1.69-.84 1.66-18.35-1.89L5.13 111l85 22.89L132 26.28l-22.91-2.45-3.8 4.9 2.48-6.59 4.15.28c.71-1.32.92-2.32.62-3s-1.33-1.29-3.09-1.42l.79-2.16a9 9 0 012.39.47 4 4 0 013 2.82 6.24 6.24 0 01-.62 3.77l20.08 2 .8 3.2-8.94 24.86zm-33.79-23.64l-4.16 10-52.36-7.08 4.69-9 9.81.95q6.1-12.81 9.65-17.52Q91.37-.19 100.22 0a10.54 10.54 0 017.43 2.88 9.44 9.44 0 012.83 7 13.83 13.83 0 01-.89 4.71q-2.11 5.46-6.1 15.64zm-4.33 5.65L63 31.74l-.53 1L111.72 39zm-7.7-22.89a13.8 13.8 0 00.88-4.71q0-5.89-6.45-5.89-8.4 0-12.92 9.13z"}})])])])])
          )
        }
      }
    